'use strict';

const DiscountView = require('./views/discount');

const Discount = {
  init(payload, done) {
    new DiscountView();
    done();
  },
};

module.exports = Discount;
